import { Link } from 'react-router-dom';
import sanitizeHtml from 'sanitize-html';
import { useSelector, useDispatch } from 'react-redux';
import {selectUser, selectUserRoles} from 'app/store/userSlice';
import { updatePublicArticle } from 'app/store/marketing/publicArticlesSlice';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import ArticleAuthorName from 'app/shared-components/article/ArticleAuthorName';
import ArticleAuthorAvatar from 'app/shared-components/article/ArticleAuthorAvatar';

export default function ArticlePreview({ article, className = '' }) {
  const dispatch = useDispatch();
  const userRoles= useSelector(selectUserRoles);
  const isAdmin= userRoles.includes('admin');
  const isSupport= userRoles.includes('support');
  const defaultImageUrl = `${window.location.origin}/assets/images/article/default_article_header.jpg`;
  
  const articleUrl = `/article/${article.slug || article.id}`;

  const handleFeaturedToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(updatePublicArticle({
      id: article.id,
      featured: e.target.checked
    }));
  };

  const handleHiddenToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(updatePublicArticle({
      id: article.id,
      hidden: e.target.checked
    }));
  };

  return (
    <article className={`${className} border border-gray-200 rounded-lg p-16 bg-white shadow-sm`}>
      <Link to={articleUrl}>
        <div className="aspect-w-16 aspect-h-9 rounded-20 overflow-hidden">
          <img
            src={article.headerImageUrl || defaultImageUrl}
            alt={article.title}
            className="object-cover"
            onError={(e) => { e.target.src = defaultImageUrl; }}
          />
        </div>
      </Link>

      <div className="mt-20">
        <div className="flex items-center gap-8 text-16 text-hs-grey-black">
          <ArticleAuthorAvatar article={article} className="w-24 h-24" mode="public" />
          <div>
            <ArticleAuthorName article={article} className="text-16" color="text-hs-grey-black" /> {new Date(article.publishDate || article.createdAt).toLocaleString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            })}
          </div>
        </div>

        <div className="flex justify-between items-start mt-8">
          <Link to={articleUrl} className="flex-1" style={{ textDecoration: 'none' }}>
            <h3 className="text-hs-grey-black text-24 leading-tight font-medium hover:text-blue-600 transition-colors">
              {article.title}
            </h3>
          </Link>
          {(isAdmin || isSupport) && (
            <div className="flex flex-col gap-4 ml-12">
              <FormControlLabel
                control={
                  <Switch
                    checked={article.featured || false}
                    onChange={handleFeaturedToggle}
                    size="small"
                    color="primary"
                  />
                }
                label="Featured"
                onClick={(e) => e.stopPropagation()}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={article.hidden || false}
                    onChange={handleHiddenToggle}
                    size="small"
                    color="primary"
                  />
                }
                label="Hidden"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}
        </div>

        {article.summary && (
          <div
            className="text-hs-grey-black text-16 mt-12"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(article.summary) }}
          />
        )}
      </div>
    </article>
  );
}